import { api } from '../../../configs/api';
import { APP_CONFIG, getAppHeader, } from '../../../configs/config';
import { ROUTE } from '../../../routes';
import SharedPropsService from '../../../SharedPropsService';
import sharedPropsService from '../../../SharedPropsService';
import { ACTION, } from './types';
import { FORECLOSURE_HANDLING, foreclosureCheck } from '../../../configs/utils';
let counter = 0;
let processInProgress = false;
export const enhanceLimit = async (action, _datastore, { instrumentTrack, navigateToBase, setDatastore, showPopup, network, ...props }) => {
    await setDatastore(action.routeId, 'manageLimit', {
        loading: true,
    });
    const user = await sharedPropsService.getUser();
    const creditId = user.linkedCredits[0].creditId;
    const response = await network.get(`${api.initForeclosureOtp}${creditId}`, {
        headers: await getAppHeader(),
    });
    if (response.status === 200) {
        await setDatastore(action.routeId, 'manageLimit', {
            error: false,
            showOtpModal: true,
            modalState: `OTP${counter}`,
            loading: false,
        });
        counter++;
    }
    else {
        showPopup({
            autoTriggerTimerInMilliseconds: APP_CONFIG.MODAL_TRIGGER_TIMEOUT,
            type: 'FAILED',
            title: 'Error',
            subTitle: response.response.data.message,
            ctaLabel: 'Retry',
            ctaAction: {
                type: ACTION.MENU,
                routeId: ROUTE.FORECLOSURE,
                payload: {},
            },
            primary: true,
        });
    }
    await setDatastore(action.routeId, 'manageLimit', {
        loading: false,
    });
};
export const verifyOtp = async (action, _datastore, { setDatastore, network, goBack, navigate }) => {
    await setDatastore(action.routeId, 'manageLimit', {
        error: false,
    });
    const user = await SharedPropsService.getUser();
    const phoneNumber = user.user.phoneNumber;
    const response = await network.post(`${api.verifyForeclosureOtp}`, {
        // @ts-ignore
        otp: action.payload.otp,
        // @ts-ignore
        phoneNo: phoneNumber
    }, {
        headers: await getAppHeader(),
        handleFromMF: true
    });
    console.warn("RESPONSE FROM THE API", response);
    if (response.status === 200) {
        if (response.data.status === "PENDING_PAYMENT" || response?.data?.status === "EXCESS_PENDING") {
            navigate(ROUTE.OUTSTANDING_DUES);
        }
        else {
            navigate(ROUTE.DASHBOARD);
        }
        await setDatastore(action.routeId, 'manageLimit', {
            error: false,
        });
    }
    else {
        console.warn("Error received is $$$$$ ", response.response.data.voltErrorCode);
        await setDatastore(action.routeId, 'manageLimit', {
            error: true,
            userName: response.response.data.message
        });
    }
};
export const getURL = async (action, _datastore, { setDatastore, network, showPopup, instrumentTrack }) => {
    instrumentTrack('EMAIL_HOLDING_STATEMENT_BUTTON_CLICKED');
    await setDatastore(action.routeId, 'continue', {
        loading: true,
    });
    const user = await sharedPropsService.getUser();
    const accountId = user.linkedBorrowerAccounts[0].accountId;
    const response = await network.get(`${api.pdfHoldingStatement}${accountId}`, {
        headers: await getAppHeader(),
    });
    if (response.status === 200) {
        await setDatastore(action.routeId, 'continue', {
            loading: false,
        });
        showPopup({
            id: 'bt_loanForeClosure_continue',
            autoTriggerTimerInMilliseconds: APP_CONFIG.MODAL_TRIGGER_TIMEOUT,
            type: 'SUCCESS',
            title: 'Email sent successfully',
            subTitle: 'Account holding details have been sent to your email address.',
            ctaLabel: 'Continue',
            ctaAction: {
                type: ACTION.MENU,
                routeId: ROUTE.MANAGE_LIMIT,
                payload: {},
            },
            primary: false,
        });
    }
    await setDatastore(action.routeId, 'continue', {
        loading: false,
    });
};
export const navigation = async (action, _datastore, { navigate, setDatastore, showPopup, asyncStorage, instrumentTrack }) => {
    console.warn("*** navigationAction props ***", action);
    // @ts-ignore
    const routeId = action.payload.routeId;
    await navigate(routeId);
};
export const goBack = async (action, _datastore, { navigate, goBack, navigateWithClear }) => {
    const prevRoute = action?.payload?.value;
    const isLoanExpired = await SharedPropsService.getIsLoanExpired();
    if (isLoanExpired) {
        await navigateWithClear(ROUTE.DASHBOARD);
    }
    else if (prevRoute === ROUTE.MY_PROFILE) {
        await navigate(ROUTE.MY_PROFILE);
    }
    else
        await goBack();
};
export const getCollateral = async (action, _datastore, { navigate, network, setDatastore, instrumentTrack }) => {
    const user = await SharedPropsService.getUser();
    const requestOptions = {
        method: 'GET',
        headers: await getAppHeader(),
    };
    await setDatastore(ROUTE.FORECLOSURE, "manageLimit", {
        loading: true
    });
    const showForeclosureCheck = await foreclosureCheck();
    if (showForeclosureCheck) {
        const processInProgressResponse = await network
            .get(`${api.processInProgress}${user.linkedCredits[0].creditId}`, {
            headers: await getAppHeader(),
            handleFromMF: true
        });
        if (processInProgressResponse?.response?.status === 400) {
            await setDatastore(ROUTE.FORECLOSURE, "manageLimit", {
                loading: false
            });
            const voltErrorCode = processInProgressResponse?.response?.data?.voltErrorCode;
            const title = processInProgressResponse?.response?.data?.message;
            let inProgressHeader;
            let description;
            switch (voltErrorCode) {
                case FORECLOSURE_HANDLING.UNLIEN_IN_PROCESS:
                    inProgressHeader = "Unpledge request in progress";
                    description = "You will be able to continue with foreclosure as soon as the request is complete. Check transaction details for more info.";
                    break;
                case FORECLOSURE_HANDLING.DISBURSAL_IN_PROCESS:
                    inProgressHeader = "Withdrawal transaction in progress";
                    description = "You will be able to foreclose as soon as the withdrawal is complete. Check transaction details for more info.";
                    break;
                case FORECLOSURE_HANDLING.REPAYMENT_IN_PROCESS:
                    inProgressHeader = "Repayment accounting in progress";
                    description = "You will be able to foreclose as soon as the repayment is accounted. Check transaction details for more info.";
                    break;
                case FORECLOSURE_HANDLING.FORECLOSURE_BUSINESS_HOUR_CHECK:
                    inProgressHeader = "Foreclosure not allowed";
                    description = "Foreclosure requests can only be submitted between 6 AM and 11 PM. Please try again during these hours.";
                    break;
                case FORECLOSURE_HANDLING.FORECLOSURE_NOT_ALLOWED_RENEWAL_IN_PROGRESS:
                    inProgressHeader = "Foreclosure not allowed";
                    description = "Foreclosure requests cannot be accepted when loan renewal is in progress.";
                    break;
                case FORECLOSURE_HANDLING.FORECLOSURE_NOT_ALLOWED_LOAN_EXPIRED:
                    inProgressHeader = "Foreclosure not allowed";
                    description = "Foreclosure requests cannot be accepted when loan is expired.";
                    break;
                case FORECLOSURE_HANDLING.FORECLOSURE_NOT_ALLOWED_FROM_LENDER:
                    inProgressHeader = "Couldn’t process your request";
                    description = title;
                    break;
                default:
                    inProgressHeader = title;
                    description = "";
                    break;
            }
            processInProgress = true;
            await setDatastore(action.routeId, 'manageLimit', {
                processInProgressData: inProgressHeader,
                showProcessInProgressCard: true,
                description: description,
                inProgressType: voltErrorCode
            });
        }
        else {
            processInProgress = false;
            let response = await network
                .get(`${api.getCollateral}${user.linkedCredits[0].creditId}`, requestOptions);
            const creditResponse = await network
                .get(`${api.getForeclosureDetails}${user.linkedCredits[0].creditId}`, requestOptions);
            if (response.status === 200) {
                instrumentTrack('CONFIRM_CLOSURE_PAGE_VIEWED');
                await setDatastore(action.routeId, 'manageLimit', {
                    loading: false,
                });
                await setDatastore(action.routeId, 'manageLimit', {
                    pledgedData: response.data || [],
                    bankData: creditResponse
                });
            }
            else {
                await setDatastore(action.routeId, 'manageLimit', {
                    showConfirmationProp: false,
                    counter: counter++
                });
            }
            await setDatastore(action.routeId, 'manageLimit', {
                pledgedData: response.data,
                bankData: creditResponse,
            });
            await setDatastore(action.routeId, 'manageLimit', {
                processInProgressData: "",
                showProcessInProgressCard: false,
            });
        }
    }
    else {
        processInProgress = false;
        let response = await network
            .get(`${api.getCollateral}${user.linkedCredits[0].creditId}`, requestOptions);
        const creditResponse = await network
            .get(`${api.getForeclosureDetails}${user.linkedCredits[0].creditId}`, requestOptions);
        if (response.status === 200) {
            instrumentTrack('CONFIRM_CLOSURE_PAGE_VIEWED');
            await setDatastore(action.routeId, 'manageLimit', {
                loading: false,
            });
            await setDatastore(action.routeId, 'manageLimit', {
                pledgedData: response.data || [],
                bankData: creditResponse
            });
        }
        else {
            await setDatastore(action.routeId, 'manageLimit', {
                showConfirmationProp: false,
                counter: counter++
            });
        }
        await setDatastore(action.routeId, 'manageLimit', {
            pledgedData: response.data,
            bankData: creditResponse,
        });
        await setDatastore(action.routeId, 'manageLimit', {
            processInProgressData: "",
            showProcessInProgressCard: false,
        });
    }
};
export const needHelp = async (action, _datastore, { navigate }) => {
    navigate(ROUTE.CONTACT_US_CARD, {
        fromInProgressProcess: processInProgress
    });
};
export const inProgressProcessNavigateAction = async (action, _datastore, { navigate }) => {
    const inProgressProcessType = action?.payload?.value;
    switch (inProgressProcessType) {
        case "REPAYMENT_IN_PROCESS":
        case "DISBURSAL_IN_PROCESS":
            await navigate(ROUTE.TRANSACTIONS);
            break;
        case "UNLIEN_IN_PROCESS":
            await navigate(ROUTE.PLEDGE_HISTORY, {
                fromInProgressProcess: true
            });
            break;
    }
};
